import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TopBar } from './components/TopBar';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { CertificationsPage } from './pages/CertificationsPage';
import { EngineersPage } from './pages/EngineersPage';
import { StaffPage } from './pages/StaffPage';
import { ContactPage } from './pages/ContactPage';
import { ComingSoonPage } from './pages/ComingSoonPage';
export function App() {
  return <Router data-id="element-0" data-mp="31ctaxf1x1e2u">
      <ScrollToTop data-id="element-1" data-mp="2wk0b95lb0vxm" />
      <div className="flex flex-col min-h-screen" data-id="element-2" data-mp="2wjgptewg3peu">
        <TopBar data-id="element-3" data-mp="2wip2ssgwz006" />
        <Navbar data-id="element-4" data-mp="2wi5qbra193tj" />
        <main className="flex-grow" data-id="element-5" data-mp="28u5z6q8t7bef">
          <Routes data-id="element-6" data-mp="28t4ju9krg2qw">
            <Route path="/" element={<HomePage data-id="element-8" data-mp="23vcjqs9ypabm" />} data-id="element-7" data-mp="28sl5t3y8dyi5" />
            <Route path="/about" element={<AboutPage data-id="element-10" data-mp="23utcq6luo6cd" />} data-id="element-9" data-mp="23w4fc33k781w" />
            <Route path="/certifications" element={<CertificationsPage data-id="element-12" data-mp="3ikr002qv3a7b" />} data-id="element-11" data-mp="23ti8k5ohswkq" />
            <Route path="/engineers" element={<EngineersPage data-id="element-14" data-mp="3mljaezbgzl56" />} data-id="element-13" data-mp="3ijftvw9y1qd1" />
            <Route path="/staff" element={<StaffPage data-id="element-16" data-mp="3mjztd6hzp62c" />} data-id="element-15" data-mp="3mkrcviybbdc9" />
            <Route path="/contact" element={<ContactPage data-id="element-18" data-mp="3rbrcwx2qabiz" />} data-id="element-17" data-mp="3mj6jhwnqi0fz" />
            <Route path="/portal" element={<ComingSoonPage data-id="element-20" data-mp="3relumgucxi8p" />} data-id="element-19" data-mp="3rcsy3udgkeef" />
          </Routes>
        </main>
        <Footer data-id="element-21" data-mp="4n7u7q58zd7" />
      </div>
    </Router>;
}